<template>
  <span ref="textEl" :class="['thread-text-component', typeClass, ellipsisLines ? 'thread-text-ellipsis' : '']" :style="computedStyles" data-testid="text" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: "ThreadText",
  props: {
    type: {
      type: String,
      default: "component",
      validator: value => ["hero", "navSubheader", "navItem", "label", "chip", "tooltipTitle", "tooltipDescription", "stepLabel", "helperText", "component", "eventInactive", "eventActive", "h6", "caption"].includes(value)
    },
    ellipsisLines: {
      type: Number,
      default: null
    },
    customStyles: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      tooltipEl: null
    };
  },
  beforeDestroy() {
    this._removeTooltip();
  },
  computed: {
    typeClass() {
      return this.type ? `text-type-${this.type}` : "";
    },
    defaultStyles() {
      const mapping = {
        hero: { fontSize: "72px", fontWeight: "800", lineHeight: "1.25" },
        navSubheader: { fontSize: "11px", fontWeight: "bold", lineHeight: "18px", textTransform: "uppercase" },
        navItem: { fontSize: "14px", fontWeight: "500", lineHeight: "22px" },
        label: { fontSize: "14px", lineHeight: "21px", fontWeight: "bold", color: "#666769" },
        chip: { fontSize: "13px", fontWeight: "500", lineHeight: "18px" },
        tooltipTitle: { fontSize: "14px", fontWeight: "bold", lineHeight: "22px", color: "white" },
        tooltipDescription: { fontSize: "14px", lineHeight: "22px", color: "white" },
        stepLabel: { fontSize: "12px", fontWeight: "bold", lineHeight: "20px" },
        helperText: { fontSize: "12px", lineHeight: "18px", fontWeight: "500" },
        component: { fontSize: "15px", lineHeight: "22px", fontWeight: "400" },
        eventInactive: { fontWeight: 700, fontSize: "12px", color: "#bfbfbf" },
        eventActive: { fontWeight: 700, fontSize: "12px", color: "#4c8ce4" },
        h6: { fontWeight: 600, lineHeight: "28px", fontSize: "18px", color: "#4A4A4A" },
        caption: { fontWeight: 400, lineHeight: "18px", fontSize: "12px", color: "#637381" }
      };
      return this.type ? mapping[this.type] : {};
    },
    computedStyles() {
      return { ...this.defaultStyles, ...this.customStyles };
    }
  },
  mounted() {
    if (this.ellipsisLines) {
      this.$el.style.webkitLineClamp = this.ellipsisLines;
    }
  },
  methods: {
    isEllipsisActive() {
      const el = this.$refs.textEl;
      return el && el.scrollHeight > el.clientHeight;
    },
    onMouseEnter() {
      if (!this.ellipsisLines || !this.isEllipsisActive()) return;
      const rect = this.$refs.textEl.getBoundingClientRect();
      this._removeTooltip();
      const el = document.createElement("span");
      el.className = "thread-tooltip-portal";
      el.textContent = this.$refs.textEl.textContent;
      el.style.cssText = `
        position: fixed;
        top: ${rect.bottom + 8}px;
        left: ${rect.left}px;
        background-color: rgba(0,0,0,0.85);
        color: white;
        padding: 6px 10px;
        border-radius: 4px;
        font-size: 13px;
        line-height: 1.5;
        z-index: 9999;
        pointer-events: none;
        max-width: 300px;
        word-wrap: break-word;
        box-shadow: 0 2px 8px rgba(0,0,0,0.2);
        white-space: normal;
      `;
      document.body.appendChild(el);
      this.tooltipEl = el;
    },
    onMouseLeave() {
      this._removeTooltip();
    },
    _removeTooltip() {
      if (this.tooltipEl) {
        this.tooltipEl.remove();
        this.tooltipEl = null;
      }
    }
  }
};
</script>

<style scoped>
.thread-text-component {
  display: block;
  position: relative;
  color: #525252;
}

/* autoprefixer: off */
.thread-text-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
/* autoprefixer: on */
</style>
